var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPatientListOpen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2563EB",
  d: "M12 14a5 5 0 0 1 5 5v2a1 1 0 1 1-2 0v-2a3 3 0 0 0-2.703-2.985L12 16H6a3 3 0 0 0-3 3v2a1 1 0 1 1-2 0v-2a5 5 0 0 1 5-5zm6.032.88a1 1 0 0 1 1.218-.718A5 5 0 0 1 23 19V21a1 1 0 0 1-2 0v-1.999l-.01-.248a3 3 0 0 0-2.24-2.655 1 1 0 0 1-.718-1.218M9 2a5 5 0 1 1 0 10A5 5 0 0 1 9 2m6.031.882a1 1 0 0 1 1.217-.72 5 5 0 0 1 3.76 4.843l-.004.208a5 5 0 0 1-3.756 4.636 1 1 0 0 1-.496-1.938 3 3 0 0 0 2.245-2.657l.01-.25A3 3 0 0 0 15.753 4.1a1 1 0 0 1-.72-1.217M9 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
})));
export default SvgPatientListOpen;